import { TILE_SIZE } from "./CameraManager";

export const CAMERA_RUNTIME = Object.freeze({
  viewportWidthPx: 384,
  viewportHeightPx: 216,
  safeZoneWidthPx: 168,
  safeZoneHeightPx: 96,
  safeZoneHalfWidthPx: 84,
  safeZoneHalfHeightPx: 48,
  viewportHalfWidthPx: 192,
  viewportHalfHeightPx: 108,
});

export interface CameraPixelPosition {
  readonly x: number;
  readonly y: number;
}

export interface PlayerPixelPosition {
  readonly x: number;
  readonly y: number;
}

export function isPlayerInSafeZone(
  player: PlayerPixelPosition,
  camera: CameraPixelPosition,
): boolean {
  const dx = Math.abs(player.x - camera.x);
  const dy = Math.abs(player.y - camera.y);
  return (
    dx <= CAMERA_RUNTIME.safeZoneHalfWidthPx &&
    dy <= CAMERA_RUNTIME.safeZoneHalfHeightPx
  );
}

export function computeFollowTarget(
  player: PlayerPixelPosition,
  camera: CameraPixelPosition,
): CameraPixelPosition {
  const { safeZoneHalfWidthPx, safeZoneHalfHeightPx } = CAMERA_RUNTIME;

  let targetX = camera.x;
  let targetY = camera.y;

  if (player.x > camera.x + safeZoneHalfWidthPx) {
    targetX = player.x - safeZoneHalfWidthPx;
  } else if (player.x < camera.x - safeZoneHalfWidthPx) {
    targetX = player.x + safeZoneHalfWidthPx;
  }

  if (player.y > camera.y + safeZoneHalfHeightPx) {
    targetY = player.y - safeZoneHalfHeightPx;
  } else if (player.y < camera.y - safeZoneHalfHeightPx) {
    targetY = player.y + safeZoneHalfHeightPx;
  }

  return { x: targetX, y: targetY };
}

export function needsOneShotCorrection(
  player: PlayerPixelPosition,
  camera: CameraPixelPosition,
): boolean {
  return !isPlayerInSafeZone(player, camera);
}

export function lerpPixelSnap(
  current: number,
  target: number,
  factor: number,
): number {
  const interpolated = current + (target - current) * factor;
  return Math.round(interpolated);
}

export function computeStaticCameraPosition(
  initialCenterTiles: { readonly x: number; readonly y: number },
): CameraPixelPosition {
  return {
    x: initialCenterTiles.x * TILE_SIZE,
    y: initialCenterTiles.y * TILE_SIZE,
  };
}
